import { createTheme } from "@mui/material";

const getStandardDialogTheme = (isLogicTab?: boolean) => {
  return createTheme({
    components: {
      MuiDialogTitle: {
        styleOverrides: {
          root: {
            borderBottom: "1px solid lightgrey",
            fontSize: 20,
            fontWeight: 400,
            fontFamily: `"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI",
                  "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
                  "Helvetica Neue", sans-serif;`,
            padding: isLogicTab ? "0px" : "15px 32px",
            marginBottom: "20px",
          },
        },
      },
      MuiDialogContent: {
        styleOverrides: {
          root: {
            padding: "15px 32px",
          },
        },
      },
      MuiDialogActions: {
        styleOverrides: {
          root: {
            padding: "15px 32px",
          },
        },
      },
    },
  });
};

export { getStandardDialogTheme };
